'use strict';
import { ModalShowHide } from '../components/modal';
import FindInStore from '../product/findinstore';
import PickupPoint from '../checkout/pickupPoint';
import { lazyload } from '../util/lazyload';
import SlovakParcelService from 'checkout/slovakParcelService/slovakParcelServicePUP';
/* global paypal $ */
/* global paypalUtils $ */
/* eslint no-console: 'off' */

export function continueButtonToggle (flag) {
    var $continueButton = $('button.submit-payment');

    var stage = (new URL(window.location)).searchParams.get('stage');
    if (stage !== 'placeOrder' && stage !== 'shipping' && stage !== null) {
        $continueButton.toggle(flag);
    }
}

function showPaymentErrorMessage (msg) {
    if ($('#checkout-main').data('checkout-stage') === 'shipping') {
        $('.js-reserve-error-checkout')
            .show()
            .find('.error-message-text')
            .text(msg);
        $('html, body').animate({
            scrollTop: $('.js-reserve-error-checkout').offset().top - 150
        }, 500);
    } else {
        $('.error-message.payment')
            .show()
            .find('.error-message-text')
            .text(msg);
    }

}

function showCartErrorMessage (msg) {
    $('.js-cart-error-reserve')
        .show()
        .find('.error-message-text')
        .text(msg);
    window.scrollTo(0, 0);
}

// paypalUtils.js
export function paypalUtilsInit () {
    var isDebugMode = true;
    var paypalUtils = {};
    const openModalExpress = new ModalShowHide('#expressButtonModal', 'isOpenExpress', true, '.js-shipping-types');
    $('body').on('click', '.js-ModalExpressButton-paypal', function (e) {
        //to remove the google pay express checkout param in case user switch from google pay to paypal
        $('.shipping-express-form input[name="isExpressGooglePay"]').remove();
        $('#add-to-condition-sale-list_express_paypal').prop('checked', false);
        $('.js-express-button').addClass('disableExpressButton');
        $('#add-to-condition-sale-list_express_paypal').parsley().reset();
        $('body').trigger('analytics:fakeExpressButton', {type: 'pay_with_paypal'});
        openModalExpress.show('isOpenExpress');
        $('.confirm-express-payment').hide();
        $('.paypal-confirm-express').show();
        $('.shipping-method-list-express .shipping-type-aggregator').sort(function (a, b) {
            if ($(a).find('.shipping-method-express-confirmed').length) {
                return -100;
            } else if ($(b).find('.shipping-method-express-confirmed').length) {
                return 100;
            }
            return $(a).data('index') - $(b).data('index');
        }).appendTo('.shipping-method-list-express');
        $('body').trigger('express-modal:open', {paymentMethod: 'PAYPAL'});
        lazyload($('#express-container')).then((rsp) => {
            $('#express-container').html(rsp).data('lazyurl', undefined);
            FindInStore.run(false);
            PickupPoint.run();
            let countryCode = document.getElementById('country-code') && document.getElementById('country-code').value ? document.getElementById('country-code').value : null;
            if ($('.page').data('action') === 'Cart-Show' && countryCode === 'SK') {
                const slovakParcelService = new SlovakParcelService();
                slovakParcelService.run();
            }
        });
    });

    if (console && isDebugMode) {
        var consoleLog = console.log;
        var consoleError = console.error;
        console.log = function () {
            consoleLog.apply(console, arguments);
        };
        console.error = function () {
            consoleError.apply(console, arguments);
        };
    } else {
        console = { // eslint-disable-line no-global-assign
            log: function () {},
            error: function () {}
        };
    }

    paypalUtils.console = console;

    paypalUtils.initButton = function (params, buttonEl) {
        var config = params;
        if (isDebugMode) {
            if (typeof config.env !== 'string') {
                console.error('paypalUtils: env is mandatory parameter. The value can be "production" or "sandbox"');
                return;
            }
            if (!(config.env === 'production' || config.env === 'sandbox')) {
                console.error('paypalUtils: The value of env parameter must be "production" or "sandbox"');
                return;
            }
            if (config.bmConfigurationInvalid) {
                console.error('Invalid configuration in BM: Merchant Tools > Site Preferences > Custom Preference > Paypal_Express_Checkout > Field: ' + config.bmConfigurationInvalid);
                return;
            }
        }

        var createPaymentUrl = config.createPaymentUrl;
        delete config.createPaymentUrl;

        var createPaymentErrorHandle = config.createPaymentErrorHandle || function (error, redirectUrl) {
            if (error === 'empty_cart') {
                window.location.reload();
            } else if (error === 'no_store_selected') {
                $('.js-checkout-error-message').removeClass('hidden');
            } else {
                window.location.href = redirectUrl;
            }
        };
        delete config.createPaymentErrorHandle;

        // https://developer.paypal.com/docs/integration/direct/express-checkout/integration-jsv4/customize-button/
        // https://developer.paypal.com/demo/checkout/#/pattern/client
        var defaultButtonConfig = {
            locale: $(buttonEl).data('locale') || 'it_IT',
            style: {
                layout: 'vertical', // horizontal, vertical
                size: 'responsive', // small, medium, large, responsive
                shape: 'rect', // pill, rect
                color: 'white', // gold, blue, silver, black
                label: 'pay',
                tagline: false,
                fundingicons: false,
                maxbuttons: 1
                // label: 'checkout',
                // checkout	The PayPal Checkout button. The default button.
                // credit	The PayPal Credit button. Initializes the credit flow. Cannot be used with any custom color option.
                // pay		The Pay With PayPal button. Initializes the checkout flow.
                // buynow	The Buy Now button. Initializes the checkout flow. The default Buy Now button is unbranded. To include PayPal branding, set branding: true.
                // paypal	The generic PayPal button. Initializes the checkout flow. This button contains only the PayPal brand logo.
                // tagline: true, // false - to disable the tagline/text beneath the button
                // maxbuttons: 4, //1-4
                // fundingicons: true, // true Displays funding instrument icons. Not valid for the credit button.
                // false Hides funding instrument icons.
            },

            funding: {
                allowed: [paypal.FUNDING.CREDIT],
                disallowed: []
                // paypal.FUNDING.CREDIT	Allow buyers to pay with PayPal Credit.					Enabled by default for US buyers.
                // paypal.FUNDING.CARD		Allow buyers to pay with their credit or debit card 	Enabled by default for all buyers.
                // paypal.FUNDING.ELV		Allow German buyers to pay with their bank account		Enabled by default for DE buyers.
            },

            payment: function (resolve, reject) {
                $('body').trigger('analytics:paymentFastCheckout', {
                    method: 'paypal'
                });
                console.log('paypalUtils: payment', 'payment url:', createPaymentUrl);

                $('.js-checkout-error-message').addClass('hidden');
                openModalExpress.hide('isOpenExpress');

                $.post(createPaymentUrl, {}, function (data) {
                    console.log('paypalUtils: Getting token data response', data);
                    if (data.error) {
                        if (data.errorType !== 'reserveInventory') {
                            createPaymentErrorHandle(data.error, data.redirectUrlStr);
                        } else {
                            if ($('.page').data('action') === 'Cart-Show' || $('#checkout-main').length === 0) {
                                showCartErrorMessage(data.errorMessage);
                            } else showPaymentErrorMessage(data.errorMessage);
                        }
                        console.error('paypalUtils: ' + createPaymentUrl + ' returned data with error');
                        reject(data.error);
                    }
                    if (!data.token) {
                        console.error('paypalUtils: data does not have token property');
                        reject('system_error');
                        return;
                    }
                    resolve(data.token);
                });
            },
            onAuthorize: function (data, actions) {
                $('body').trigger('checkout:afterHandleNextStage', {
                    stage: 3
                });
                console.log('paypalUtils: onAuthorize.data', data);
                return actions.redirect();
            },
            onCancel: function (data, actions) { // eslint-disable-line no-unused-vars
                console.log('paypalUtils: onCancel.data', data);
                // return actions.redirect();
            },
            onError: function (msg) {
                console.log('paypalUtils: onError.msg', msg);
            }
        };

        config = $.extend(defaultButtonConfig, config); // eslint-disable-line no-param-reassign

        console.log('paypalUtils: paypal.Button.render config', config);

        paypal.Button.render(config, buttonEl);
    };

    paypalUtils.initFraudnet = function () {
        var scriptBaseURL = 'https://www.paypalobjects.com/webstatic/r/fb/';
        var dom;
        var doc;
        var where;
        var iframe = document.createElement('iframe');
        iframe.src = 'about:blank';
        iframe.title = '';
        iframe.role = 'presentation'; // a11y
        (iframe.frameElement || iframe).style.cssText = 'width: 0; height: 0; border: 0';
        where = document.getElementsByTagName('script');
        where = where[where.length - 1];
        where.parentNode.insertBefore(iframe, where);
        try {
            doc = iframe.contentWindow.document;
        } catch (e) {
            dom = document.domain;
            iframe.src = "javascript:var d=document.open();d.domain='" + dom + "';void(0);"; // eslint-disable-line  no-script-url
            doc = iframe.contentWindow.document;
        }
        doc.open()._l = function () {
            var js = this.createElement('script');
            if (dom) {
                this.domain = dom;
            }
            js.id = 'js-iframe-async';
            js.src = scriptBaseURL + 'fb-all-prod.pp.min.js';
            this.body.appendChild(js);
        };
        doc.write('<body onload="document._l();">');
        doc.close();
    };

    window.paypalUtils = paypalUtils;
};

// paypalMFRA.js
export function paypalMFRAInit () {
    // var console = paypalUtils.console;

    console.log('MFRA!');

    $('.js_paypal_button').each(function () {
        var $paypalButton = $(this);
        if ($paypalButton.data('isInited')) {
            return;
        }
        var config = $paypalButton.data('paypalConfig');
        if (typeof config !== 'object') {
            console.error('paypalMFRA: not valid data-paypal-config');
            return;
        }
        if (config.billingAgreementFlow) {
            var billingAgreementFlowConfig = {
                isShippingAddressExist: config.billingAgreementFlow.isShippingAddressExist,
                startBillingAgreementCheckoutUrl: config.billingAgreementFlow.startBillingAgreementCheckoutUrl
            };
            if (!config.style) {
                config.style = {
                    layout: 'horizontal',
                    label: 'paypal',
                    maxbuttons: 1,
                    fundingicons: false,
                    shape: 'rect',
                    size: 'responsive',
                    tagline: false
                };
            }
            config.style.maxbuttons = 1;
            config.payment = function () {};
            config.onAuthorize = function () {};
            config.validate = function (actions) {
                return actions.disable();
            };
            config.onClick = function () {
                if (billingAgreementFlowConfig.isShippingAddressExist === true) {
                    window.location.href = billingAgreementFlowConfig.startBillingAgreementCheckoutUrl;
                    return;
                }
                var $paypalAddShippingAddressModal = $('#paypalAddShippingAddressModal');
                $('body').append($paypalAddShippingAddressModal);
                $('#paypalAddShippingAddressModal').modal();
            };
            delete config.billingAgreementFlow;
        }
        paypalUtils.initButton(config, $paypalButton[0]);
        $paypalButton.data('isInited', true);
    });

    var $paymentOptionsTabs = $('.payment-options[role=tablist] a[data-toggle="tab"]');

    $('.js_paypal_button_on_billing_form').each(function () {
        var $paypalButton = $(this);
        if ($paypalButton.data('isInited')) {
            return;
        }
        var config = $paypalButton.data('paypalConfig');
        if (typeof config !== 'object') {
            console.error('paypalMFRA: not valid data-paypal-config');
            return;
        }

        var $paypalContent = $paypalButton.parents('.paypal-content:first');
        var $useAnotherAccountCheckbox = $paypalContent.find('input[name$="billing_paypal_useAnotherAccount"]');
        var $useAnotherAccountCheckboxWrap = $paypalContent.find('.js_paypal-use-another-account-wrap');
        var $saveBillingAgreementCheckbox = $paypalContent.find('input[name$="billing_paypal_saveBillingAgreement"]');
        var $saveBillingAgreementWrap = $('.js_paypa-save-ba-wrap');
        var $useCustomerBillingAgreementCheckbox = $paypalContent.find('input[name$="billing_paypal_useCustomerBillingAgreement"]');
        var $errorContainer = $paypalContent.find('.js_paypal_error');
        var $emailContainer = $paypalContent.find('.js_paypal_emailConainter');

        if ($useAnotherAccountCheckbox.length) {
            $useAnotherAccountCheckbox[0].checked = false;
            $useAnotherAccountCheckbox.change(function () {
                $paypalButton.parent().toggle(this.checked);
                continueButtonToggle(!this.checked);
                $paypalContent.data('paypalIsHideContinueButton', this.checked);
                $saveBillingAgreementWrap.toggle(this.checked);
                if ($useCustomerBillingAgreementCheckbox.length && this.checked) {
                    $useCustomerBillingAgreementCheckbox[0].checked = !this.checked;
                }
                if (this.checked) {
                    $emailContainer.hide();
                    $emailContainer.find('input').attr('disabled', 'disabled');
                } else {
                    $emailContainer.show();
                    $emailContainer.find('input').removeAttr('disabled');
                }
            });
        }

        if ($useCustomerBillingAgreementCheckbox.length) {
            $useCustomerBillingAgreementCheckbox[0].checked = $useCustomerBillingAgreementCheckbox.data('paypalChecked');
            $useCustomerBillingAgreementCheckbox.change(function () {
                $useAnotherAccountCheckboxWrap.toggle(!this.checked);
                $paypalButton.parent().toggle(!this.checked);
                continueButtonToggle(this.checked);
                $paypalContent.data('paypalIsHideContinueButton', !this.checked);
                if ($saveBillingAgreementCheckbox.length) {
                    $saveBillingAgreementCheckbox[0].checked = false;
                    $saveBillingAgreementWrap.toggle(!this.checked);
                }
                if (this.checked === false) {
                    $useAnotherAccountCheckbox.change();
                }
                if (this.checked) {
                    $emailContainer.hide();
                    $emailContainer.find('input').attr('disabled', 'disabled');
                } else {
                    $emailContainer.show();
                    $emailContainer.find('input').removeAttr('disabled');
                }
            });

            var isRecurrentFlow = $('#checkout-main').data('hasBillingAgreement');
            var isExpressFlow = $('#checkout-main').data('expressFlow');
            var isPayPalSelected = $('#PayPal[type="radio"]').is(':checked');
            var billingAgreementCheckbox = !isRecurrentFlow && !isExpressFlow && isPayPalSelected ? false : $paypalContent.find('.js_useCustomerFillingAgreementState').val();
            $useCustomerBillingAgreementCheckbox[0].checked = billingAgreementCheckbox;
            $useCustomerBillingAgreementCheckbox.change();
        }

        if ($saveBillingAgreementCheckbox.length) {
            $saveBillingAgreementCheckbox[0].checked = false;
        }

        var $form = $('#dwfrm_billing');

        config.payment = function (resolve, reject) {
            $errorContainer.hide();
            var paymentForm = $form.serialize();
            paymentForm += '&recurrentStatus=' + $('#checkout-main').data('hasBillingAgreement');
            $.ajax({
                url: $form.attr('action'),
                method: 'POST',
                data: paymentForm,
                success: function (data) {
                    if (data.error) {
                        if (data.errorMessage) {
                            showPaymentErrorMessage(data.errorMessage);
                            reject();
                            return;
                        }
                        if (data.paypalProcessorResult && data.paypalProcessorResult.error) {
                            $errorContainer.text(data.paypalProcessorResult.error).show();
                        }
                        // If there are errors on the billing form return
                        if (data.fieldErrors.length >= 1 && !$.isEmptyObject(data.fieldErrors[0])) {
                            let keys = Object.keys(data.fieldErrors[0]);
                            for (let i = 0; i < keys.length; i++) {
                                $('.' + keys[i] + ' input').addClass('is-invalid');
                            }
                            reject();
                            return;
                        }
                        // if (data.fieldErrors.length) {
                        //     $form.submit();
                        // }
                        if (data.serverErrors.length) {
                            data.serverErrors.forEach(function (error) {
                                $('.error-message').show();
                                $('.error-message-text').text(error);
                            });
                        }
                        if (data.cartError) {
                            window.location.href = data.redirectUrl;
                        }
                        reject();
                    } else {
                        localStorage.setItem('selectedPaymentMethod', 'PayPal');
                        resolve(data.paypalProcessorResult.paypalToken);
                    }
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    }
                }
            });
        };

        paypalUtils.initButton(config, $paypalButton[0]);
        $paypalButton.data('isInited', true);
    });

    $paymentOptionsTabs.off('shown.bs.tab');
    $paymentOptionsTabs.on('shown.bs.tab', function (e) {
        console.log('Event shown.bs.tab detected');
        $paymentOptionsTabs.each(function () {
            var $tabContent = $($(this).attr('href'));
            // if ($tabContent.hasClass('js_paypal-content')) {
            if (this === e.target) {
                $tabContent.find('input, textarea, select').removeAttr('disabled', 'disabled');
            } else {
                $tabContent.find('input, textarea, select').attr('disabled', 'disabled');
            }
            // }
        });
        var $currentTabContent = $($(e.target).attr('href'));
        console.log($currentTabContent);
        if ($currentTabContent.find('.js_paypal_button_on_billing_form').length) {
            continueButtonToggle(!$currentTabContent.data('paypalIsHideContinueButton'));
        } else {
            continueButtonToggle(true);
        }
    });

    if ($('.js_paypal_fraudnet_data').length) {
        paypalUtils.initFraudnet();
    }
};
